import { api } from "@/lib/api";

const base = "/api/reconciliation";

export interface MethodBreakdownRow {
  method: string;
  received: number;
  refunded: number;
  count: number;
}

export interface StreamMethodBreakdown {
  OPD: MethodBreakdownRow[];
  LAB: MethodBreakdownRow[];
  DAY_CARE: MethodBreakdownRow[];
  ADDITIONAL_SERVICES: MethodBreakdownRow[];
  IPD: MethodBreakdownRow[];
}

export interface DaySummary {
  date: string;
  from?: string;
  to?: string;
  totalReceived: number;
  totalRefunded: number;
  expectedCash: number;
  /** Cash paid out for receptionist-created expenses marked PAID in CASH (expense `expenseDate` on this calendar day). */
  expenseCashOutflow: number;
  expenseCashOutflowCount: number;
  byMethod: MethodBreakdownRow[];
  /** Billed / accrued on this calendar day */
  generated: {
    opd: number;
    lab: number;
    ipd: number;
    dayCare: number;
    additionalServices: number;
    total: number;
  };
  /** Cash in on this day (OPD bills + IPD deposits/refunds), split by stream */
  collected: {
    opd: number;
    lab: number;
    ipd: number;
    dayCare: number;
    additionalServices: number;
    total: number;
  };
  collectedByStreamAndMethod: StreamMethodBreakdown;
  patientWiseCollected?: Array<{
    patientId: string;
    patientName: string;
    uhid: string | null;
    phone: string | null;
    received: number;
    refunded: number;
    net: number;
    byMethod: MethodBreakdownRow[];
  }>;
}

export interface CashierSession {
  id: string;
  hospitalId: string;
  sessionDate: string;
  openedAt: string;
  closedAt?: string;
  openedById: string;
  closedById?: string;
  expectedCash: number;
  actualCash?: number;
  variance?: number;
  notes?: string;
  openedBy?: { id: string; name: string };
  closedBy?: { id: string; name: string };
}

export const reconciliationApi = {
  getDaySummary: (date?: string) =>
    api.get<{ data: DaySummary }>(`${base}/summary`, { params: date ? { date } : {} }),
  getSessions: (from?: string, to?: string) =>
    api.get<{ data: CashierSession[] }>(`${base}/sessions`, { params: { from, to } }),
  openSession: (date?: string) =>
    api.post<{ data: CashierSession }>(`${base}/session/open`, date ? { date } : {}),
  closeSession: (id: string, data: { actualCash: number; notes?: string }) =>
    api.post<{ data: CashierSession }>(`${base}/session/${id}/close`, data),
};
